import * as API_CONSTANT from "../constants";

export const verifyLink = (link, pin) =>
  fetch(`${API_CONSTANT.cnp_sso_path}/verify/link`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({
      link,
      pin
    }),
  }).then((res) => res.json());
